import { GradientArea } from '../../Common/Charts/GradientArea';
import { useProductionTemporalChartsDataContext } from './hooks/useProductionTemporalChartsDataContext';

export const ProductionAvgPermanence = () => {
    const { chartData } = useProductionTemporalChartsDataContext();

    const mediaPermAno = chartData?.avgPermanence || {};
    const subtitles = Object.keys(mediaPermAno);
    const values = Object.values(mediaPermAno);

    return (
        <GradientArea
            title={'Média de Permanência por Ano'}
            values={values}
            subtitles={subtitles}
        />
    );
};
